import JotFormReact from 'jotform-react';

const custom = () => {
    return (<div>
      
      <JotFormReact
        formURL="https://form.jotform.com/222597845951571"
      />
    </div>)
}

export default custom;
